import {AxiosError} from 'axios';

import {
    Completable,
    CtaBlockDTO,
    KashableResponseDTO,
    UsersPreferencesDTO,
    UsersWebDTO,
} from 'kashable-mobile-common';

import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

const fetchUser: () => Promise<Completable<UsersWebDTO>> = () => {
    return axios
        .get<KashableResponseDTO<UsersWebDTO>>('/secured/user/profile')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const updatePreferences: (usersPrefs: UsersPreferencesDTO) => Promise<Completable<UsersPreferencesDTO>> = (
    pref,
) => {
    return axios
        .put<KashableResponseDTO<UsersPreferencesDTO>>('/secured/user/preferences/web', pref)
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const getCtaBlock: () => Promise<Completable<Array<CtaBlockDTO>>> = () => {
    return axios
        .get<KashableResponseDTO<Array<CtaBlockDTO>>>('/secured/user/cta-block')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {fetchUser, getCtaBlock, updatePreferences};
